const CellType = {
  Origin: 'origin',
  Destination: 'destination',
  Detail: 'detail',
  Interchange: 'interchange',
  Transfer: 'transfer',
}

export {
  CellType,
}
